import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { getSelectedNote, getSelectedNoteIsDeletable, getSelectedNoteIsShareable, getSelectedNoteText, } from 'NotesApp/ts/apps/notes-app/state/notes.selectors';
import { DESC } from 'NewAngular/constants/core.constants';
import { NOTE_SECURITY } from 'NotesApp/ts/apps/notes-app/notes.constants';
import { NOTES_MODAL_SLICE_KEY } from 'NotesApp/ts/apps/notes-app/state/notes.constants';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { SharingModalComponent } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.component';
import { getNewSortDirectionCssClasses, getSortColumnAndDirection, initializeSortDirectionCssClasses, } from 'NewAngular/utils/sort/table-sort';
import { collapseNote, expandNote, setSelectedNote } from 'NotesApp/ts/apps/notes-app/state/notes.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i8 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
function NotesListComponent_tr_18_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵtext(3, "Shared");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipTitle", ctx_r2.getShareTooltipTitle(note_r2))("tooltipPlacement", "right");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function NotesListComponent_tr_18_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NotesListComponent_tr_18_div_2_div_3_Template, 4, 3, "div", 23);
    i0.ɵɵpipe(4, "isSharedWithOthers");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", note_r2.content, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 2, note_r2));
} }
function NotesListComponent_tr_18_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵtext(3, "Shared");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipTitle", ctx_r2.getShareTooltipTitle(note_r2))("tooltipPlacement", "right");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function NotesListComponent_tr_18_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "div")(3, "a", 28);
    i0.ɵɵlistener("click", function NotesListComponent_tr_18_div_3_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r4); const note_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.shrinkNote(note_r2.id)); });
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "strong");
    i0.ɵɵtext(6, "Less");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(7, NotesListComponent_tr_18_div_3_div_7_Template, 4, 3, "div", 23);
    i0.ɵɵpipe(8, "isSharedWithOthers");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", note_r2.content, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 2, note_r2));
} }
function NotesListComponent_tr_18_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵtext(3, "Shared");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipTitle", ctx_r2.getShareTooltipTitle(note_r2))("tooltipPlacement", "right");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function NotesListComponent_tr_18_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3, " ... ");
    i0.ɵɵelementStart(4, "a", 29);
    i0.ɵɵlistener("click", function NotesListComponent_tr_18_div_4_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r5); const note_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.extendNote(note_r2.id)); });
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "strong");
    i0.ɵɵtext(7, "More");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, NotesListComponent_tr_18_div_4_div_8_Template, 4, 3, "div", 23);
    i0.ɵɵpipe(9, "isSharedWithOthers");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", note_r2.content.slice(0, 180), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 2, note_r2));
} }
function NotesListComponent_tr_18_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", note_r2.sharing.client_group_name);
} }
function NotesListComponent_tr_18_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("click", function NotesListComponent_tr_18_div_14_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const note_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.shareHandler(note_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const note_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.hasShareableClientGroups || !note_r2.sharing.is_owner || !note_r2.security_shared_or_not_shareable)("tooltipPlacement", "bottom")("tooltipTitle", "Share");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-share");
} }
function NotesListComponent_tr_18_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵlistener("click", function NotesListComponent_tr_18_div_15_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const note_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.shareHandler(note_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r2.shareable)("tooltipPlacement", "bottom")("tooltipTitle", "Share");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-share");
} }
function NotesListComponent_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 11)(1, "td");
    i0.ɵɵtemplate(2, NotesListComponent_tr_18_div_2_Template, 5, 4, "div", 12)(3, NotesListComponent_tr_18_div_3_Template, 9, 4, "div", 13)(4, NotesListComponent_tr_18_div_4_Template, 10, 4, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelement(6, "div", 14);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelement(9, "div", 15);
    i0.ɵɵtemplate(10, NotesListComponent_tr_18_div_10_Template, 1, 1, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td")(12, "div")(13, "div", 17);
    i0.ɵɵtemplate(14, NotesListComponent_tr_18_div_14_Template, 2, 4, "div", 18)(15, NotesListComponent_tr_18_div_15_Template, 2, 4, "div", 19);
    i0.ɵɵelementStart(16, "div", 20);
    i0.ɵɵlistener("click", function NotesListComponent_tr_18_Template_div_click_16_listener() { const note_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.deleteNote(note_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(17, "svg", 21);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const note_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", note_r2.content.length < 180);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", note_r2.expanded && note_r2.content.length >= 180);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !note_r2.expanded && note_r2.content.length >= 180);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(7, 12, note_r2.create_date));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", note_r2.sharing.owner_name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !note_r2.sharing.is_owner);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.enableSharing && ctx_r2.noteType === ctx_r2.NOTE_SECURITY);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.enableSharing && ctx_r2.noteType !== ctx_r2.NOTE_SECURITY);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !note_r2.sharing.is_owner)("tooltipPlacement", "bottom")("tooltipTitle", "Delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-delete");
} }
function NotesListComponent_ycn_sharing_modal_20_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-sharing-modal", 33);
    i0.ɵɵlistener("completeHandler", function NotesListComponent_ycn_sharing_modal_20_Template_ycn_sharing_modal_completeHandler_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.shareCallback()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("shareableItem", ctx_r2.selectedNoteShareableItem)("excludeEditPermission", true);
} }
/**
 * This enum represents the possible valid values for sorting on the notes modal.
 */
export var SecurityNotesModalSortColumn;
(function (SecurityNotesModalSortColumn) {
    SecurityNotesModalSortColumn["DATE"] = "date";
    SecurityNotesModalSortColumn["AUTHOR"] = "author";
})(SecurityNotesModalSortColumn || (SecurityNotesModalSortColumn = {}));
export const NOTES_DEFAULT_SORT_DIRECTIONS = { date: DESC };
/**
 * NotesListComponent
 *
 * List of Notes for a Security with buttons to share and delete notes.
 */
export class NotesListComponent {
    set notesValue(notes) {
        this.notes = notes;
        this.sortNotes();
    }
    constructor(changeDetector, store) {
        this.changeDetector = changeDetector;
        this.store = store;
        this.enableSharing = true;
        this.deleteHandler = new EventEmitter();
        this.sharingCallback = new EventEmitter();
        this.shareable = false;
        this.hasShareableClientGroups = window.USER.shareableClientGroups.length > 0;
        // Sorting properties
        this.sortDirectionCssClasses = initializeSortDirectionCssClasses(['date', 'author']);
        this.SORT_COLUMNS = SecurityNotesModalSortColumn;
        this.sortColumn = SecurityNotesModalSortColumn.DATE;
        this.sortDirection = DESC;
        this.NOTE_SECURITY = NOTE_SECURITY;
        this.mapStateToComponent = (state) => {
            this.selectedNote = getSelectedNote(state);
            this.selectedNoteIsDeletable = getSelectedNoteIsDeletable(state);
            this.selectedNoteIsShareable = getSelectedNoteIsShareable(state);
            this.selectedNoteText = getSelectedNoteText(state);
            if (this.selectedNote) {
                this.selectedNoteShareableItem = {
                    id: this.selectedNote.id,
                    name: '',
                    sharing: this.selectedNote.sharing,
                };
            }
        };
        this.storeSubscription = this.store.select(NOTES_MODAL_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnInit() {
        const directionClass = this.sortDirection === DESC ? 'th-sort-desc' : 'th-sort-asc';
        this.sortDirectionCssClasses[this.sortColumn][directionClass] = true;
        this.shareable = !!this.sharing?.client_group_id && this.sharing.is_owner;
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setSortBy(newSortColumn) {
        const { sortColumn, sortDirection } = getSortColumnAndDirection(NOTES_DEFAULT_SORT_DIRECTIONS, this.sortColumn, newSortColumn, this.sortDirection);
        this.sortDirectionCssClasses = getNewSortDirectionCssClasses(this.sortDirectionCssClasses, this.sortColumn, sortColumn, sortDirection);
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
        this.sortNotes();
    }
    sortNotes() {
        if (this.notes?.length) {
            const sortedNotes = [...this.notes].sort((firstNote, secondNote) => {
                return this.sortColumn === SecurityNotesModalSortColumn.AUTHOR
                    ? this.compareAuthors(firstNote, secondNote)
                    : this.compareDates(new Date(firstNote.create_date), new Date(secondNote.create_date));
            });
            if (this.sortDirection === DESC) {
                sortedNotes.reverse();
            }
            this.notes = sortedNotes;
        }
    }
    compareAuthors(firstNote, secondNote) {
        const comparison = firstNote.sharing.owner_name.localeCompare(firstNote.sharing.owner_name);
        if (comparison === 0) {
            // If two notes have the same owner name, secondary sort by create_date
            return this.compareDates(new Date(firstNote.create_date), new Date(secondNote.create_date));
        }
        return comparison;
    }
    compareDates(firstDate, secondDate) {
        if (firstDate < secondDate)
            return -1;
        if (firstDate > secondDate)
            return 1;
        return 0;
    }
    /**
     * Collapses a Note text to only show a preview. Dispatches `collapseNote` to update the state for that Note.
     *
     * @param noteId: Note's ID.
     */
    shrinkNote(noteId) {
        this.store.dispatch(collapseNote({ noteId }));
    }
    /**
     * Extends a Note text to show it all. Distpatches `expandNote` to update the state for that Note.
     *
     * @param noteId: Note's ID.
     */
    extendNote(noteId) {
        this.store.dispatch(expandNote({ noteId }));
    }
    /**
     * Track by helper for the `forEach` directive.
     *
     * @param index: Index of the current Note
     * @param note: Current Note.
     */
    trackById(index, note) {
        return note.id;
    }
    /**
     * Handler for the Share button. Dispatches `setSelectedNote` and then opens the Share modal.
     *
     * @param selectedNote: Shared Note object.
     */
    shareHandler(selectedNote) {
        this.store.dispatch(setSelectedNote({ selectedNote }));
        if (this.selectedNoteIsShareable) {
            // We need to manually detect changes so that `selectedNoteShareableItem` gets updated before opening
            // the share modal. It avoids async issues and the modal opening for the wrong note.
            this.changeDetector.detectChanges();
            this.shareModal.openModal();
        }
    }
    /**
     * Callback for the Share modal that gets called after finishing the share action.
     */
    shareCallback() {
        this.sharingCallback.emit();
    }
    /**
     * Handler for the confirm delete modal button. If confirmed, deletes the Note and update the state.
     *
     * @param confirmed: True if the deletion is confirmed.
     */
    confirmDeleteHandler(confirmed) {
        if (confirmed && this.selectedNote) {
            this.deleteHandler.emit(this.selectedNote.id);
        }
    }
    /**
     * Handler for the Delete button. Opens a confirmation modal.
     *
     * @param selectedNote: Delete Note object.
     */
    deleteNote(selectedNote) {
        this.store.dispatch(setSelectedNote({ selectedNote }));
        if (this.selectedNoteIsDeletable) {
            this.confirmDeleteModal.openModal();
        }
    }
    /**
     * Returns the tooltip text for the Share icon.
     *
     * @param note: Note object.
     */
    getShareTooltipTitle(note) {
        return `Shared (${note.sharing.permission}) with ${note.sharing.client_group_name}`;
    }
}
NotesListComponent.ɵfac = function NotesListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotesListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.Store)); };
NotesListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotesListComponent, selectors: [["ycn-notes-list"]], viewQuery: function NotesListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SharingModalComponent, 5);
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.shareModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDeleteModal = _t.first);
    } }, inputs: { enableSharing: "enableSharing", sharing: "sharing", noteType: "noteType", notesValue: "notesValue", name: "name" }, outputs: { deleteHandler: "deleteHandler", sharingCallback: "sharingCallback" }, standalone: false, decls: 21, vars: 9, consts: [[1, "modal-section"], [1, "divider-horizontal"], [1, "notes-title", "modal-section-title"], [1, "table", "table-portfolios"], [1, "text-thin", "th-sort", 2, "cursor", "default"], ["data-test-id", "date-column", 1, "text-thin", "colTxtShort", "th-sort", 3, "click", "ngClass"], ["data-test-id", "author-column", 1, "text-thin", "colTxtShort", "th-sort", 3, "click", "ngClass"], [1, "text-thin", "colTxtShort"], ["class", "note", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "shareableItem", "excludeEditPermission", "completeHandler", 4, "ngIf"], [1, "note"], [4, "ngIf"], ["class", "note-text", 4, "ngIf"], [1, "note-date", 3, "textContent"], [1, "note-author", 3, "textContent"], ["class", "note-company", 3, "textContent", 4, "ngIf"], [1, "note-controls"], ["class", "btn btn-xs btn-circle btn-transparent", "ycnDisabled", "", "ycnTooltip", "", 3, "disabled", "tooltipPlacement", "tooltipTitle", "click", 4, "ngIf"], ["class", "btn btn-xs btn-circle btn-transparent", "data-test-id", "share", "ycnDisabled", "", "ycnTooltip", "", 3, "disabled", "tooltipPlacement", "tooltipTitle", "click", 4, "ngIf"], ["data-test-id", "delete", "ycnDisabled", "", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "disabled", "tooltipPlacement", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "note-text", 2, "word-break", "break-word"], ["class", "note-shared", "ycnTooltip", "", 3, "tooltipTitle", "tooltipPlacement", 4, "ngIf"], ["ycnTooltip", "", 1, "note-shared", 3, "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", 2, "margin-left", "0", 3, "name"], [1, "form-label", "form-label-thin"], [1, "note-text"], ["href", "javascript:void(0)", "data-test-id", "less", 1, "text-blue", 3, "click"], ["href", "javascript:void(0)", "data-test-id", "more", 1, "text-blue", 3, "click"], [1, "note-company", 3, "textContent"], ["ycnDisabled", "", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "disabled", "tooltipPlacement", "tooltipTitle"], ["data-test-id", "share", "ycnDisabled", "", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "disabled", "tooltipPlacement", "tooltipTitle"], [3, "completeHandler", "shareableItem", "excludeEditPermission"]], template: function NotesListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "table", 3)(5, "thead")(6, "tr")(7, "th", 4)(8, "span");
        i0.ɵɵtext(9, "Notes");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "th", 5);
        i0.ɵɵlistener("click", function NotesListComponent_Template_th_click_10_listener() { return ctx.setSortBy(ctx.SORT_COLUMNS.DATE); });
        i0.ɵɵelementStart(11, "span");
        i0.ɵɵtext(12, "Date");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "th", 6);
        i0.ɵɵlistener("click", function NotesListComponent_Template_th_click_13_listener() { return ctx.setSortBy(ctx.SORT_COLUMNS.AUTHOR); });
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15, "Author");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(16, "th", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "tbody");
        i0.ɵɵtemplate(18, NotesListComponent_tr_18_Template, 18, 14, "tr", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(19, "ycn-confirm-modal", 9);
        i0.ɵɵlistener("confirmHandler", function NotesListComponent_Template_ycn_confirm_modal_confirmHandler_19_listener($event) { return ctx.confirmDeleteHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, NotesListComponent_ycn_sharing_modal_20_Template, 1, 2, "ycn-sharing-modal", 10);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.name, " Notes");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", ctx.sortDirectionCssClasses[ctx.SORT_COLUMNS.DATE]);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.sortDirectionCssClasses[ctx.SORT_COLUMNS.AUTHOR]);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.notes)("ngForTrackBy", ctx.trackById);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "OK")("confirmHeader", "Delete Note")("confirmText", "Are you sure you want to delete this note?");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedNoteShareableItem);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.ConfirmModalComponent, i4.DisabledDirective, i5.IconDirective, i6.SharingModalComponent, i7.TooltipDirective, i2.DatePipe, i8.IsSharedWithOthersPipe], encapsulation: 2 });
